import axios from "axios";
import { APIOverrides } from "../../ApiOverrides";
import type { PlayerPremiumItem, PremiumItemProps } from "../../types";

let AUTH_SVC_API = ''

export const PremiumApi = {
    setEnvironment: () => {
        const endpoints = APIOverrides.getEndpoints();
        AUTH_SVC_API = endpoints['AUTH_SVC_API'] as string;
    },
    purchasePremiumItem: async(premium_item_id:string, type:'day'|'month'):Promise<PlayerPremiumItem | undefined> => {
        try {
            const resp = await axios.post(`${AUTH_SVC_API}/v1/players/premium/item/purchase`, { premium_item_id, type })
            return resp.data.player_premium_item
        } catch (e) {
            console.log(e)
            return undefined
        }
    }
}

export const PremiumHelpers = {
    getItemFromIdentifer : (identifier:string, premium_items?:PremiumItemProps[], player_premium_items?:PlayerPremiumItem[]):{ player_premium_item?:PlayerPremiumItem, premium_item?:PremiumItemProps } => {
        if(!premium_items){ return {} }
        let premium_item = premium_items.find(pi => pi.identifier == identifier);
        if(!premium_item){ return {} }
        if(!player_premium_items){ return { premium_item } }
        let player_premium_item = player_premium_items.find(ppi => ppi.premium_item_id == premium_item.premium_item_id);
        return { premium_item, player_premium_item }
    }
}